/**
 * Created by Amit Panghal
 */

import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Power2, Power3, Timeline, TimelineLite, TweenLite, Elastic} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SpacierArcadeGameConfig} from "../../SpacierArcadeGameConfig";

export class SAIndividualWinCountUp extends BitmapWinCountUp {
    private _countBg:PIXI.Sprite;
    constructor() {
        super({
            font : {
                name : "mw_font",
                size : 7
            },
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
    }

    protected initAnimations():void{
        super.initAnimations();
        this._countUpContainer = new PIXI.Sprite();
        this._countUpContainer.anchor.set(0.5, 0.5);
        this.setPosition();
        StageManager.getLayer(SpacierArcadeGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this);

        this._countBg = new PIXI.Sprite(GameResources.getTextures("countupBg")[0]);
        this._countBg.anchor.set(0.5, 0.5);
        this._countBg.alpha = 0;
        this._countBg.position.set(0, 0);
        this._countUpContainer.addChild(this._countBg);
        this._countUpContainer.addChild(this._countUp);
        this.addChild(this._countUpContainer);
    }

    public setPosition(posDelta:number = 0):void{
        this.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5 + GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_HEIGHT * 0.51 +  GameConfig.instance.REEL_AREA_POS_Y + posDelta);
    }

    public getCountUpAnimation(from:number, to:number, duration:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUpContainer.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, {
                duration : duration,
                ease : from == 0 ? Power3.easeInOut : Power2.easeOut
            }),
            TweenLite.fromTo(this._countUpContainer.scale, 0.6,
                {x : 0.5, y : 0.5},
                {
                    x : 0.7,
                    y : 0.7,
                    ease : Elastic.easeOut.config(2, 1)
                })
        ]);
        timeline.add([
            TweenLite.to(this._countUpContainer.scale, 0,
                {x : 0.5, y : 0.5})
        ]);
        return timeline;
    }

    protected getAbortAnimation(endValue:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            TweenLite.fromTo(this._countUpContainer.scale, 0,
                {x : 0.5, y : 0.5},
                {
                    x : 0.7,
                    y : 0.7,
                    ease : Elastic.easeOut.config(2, 1)
                }),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);

        return timeline;
    }

    public getEndingAnimation():Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(
            () =>  {this._countBg.alpha = 0;
                this._countUp.alpha = 0;
                this._countUpContainer.alpha = 0;
        }
        ); // stay a while after count up.
        return timeline;
    }
}